import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { api } from './api';

// Server-backed stars shared by everyone with the PIN. Toggles are
// optimistic and roll back if the save fails.
type StarsState = {
  stars: Record<string, boolean>;
  toggle: (slug: string) => void;
};

const Ctx = createContext<StarsState>({ stars: {}, toggle: () => {} });

export function StarsProvider({ children }: { children: ReactNode }) {
  const [stars, setStars] = useState<Record<string, boolean>>({});

  useEffect(() => {
    api.stars().then(setStars).catch(() => {});
  }, []);

  function toggle(slug: string) {
    const next = !stars[slug];
    setStars((s) => ({ ...s, [slug]: next }));
    api.setStar(slug, next).catch(() => {
      setStars((s) => ({ ...s, [slug]: !next }));
    });
  }

  return <Ctx.Provider value={{ stars, toggle }}>{children}</Ctx.Provider>;
}

export function useStars() {
  return useContext(Ctx);
}
